import React, { useContext } from 'react';
import QuestionLabel from './QuestionLabel';
import PhoneInput from 'react-phone-number-input/input';
import 'react-phone-number-input/style.css';
import PhoneInputWithCountry from 'react-phone-number-input';
import { ErrorContext } from '../../../lib/ErrorContext';
import { FormContext } from '../FormContext.jsx';
import { getBrowserTimezone } from '~/lib/DateTime';

const PhoneQuestion = ({ label, value, setValue, settings }) => {
    const optOutSuffix = ' (no SMS)';
    const isOptedOut = value?.indexOf(optOutSuffix) > -1;
    const phone = value?.replace(optOutSuffix, '');

    const { hasSms, form } = useContext(FormContext);
    const businessName = form?.business?.name;
    const showOptOut = hasSms || isOptedOut;

    let defaultCountry = 'US';
    const timezone = getBrowserTimezone();
    if (timezone.indexOf('Australia') > -1) {
        defaultCountry = 'AU';
    } else if (timezone.indexOf('London') > -1) {
        defaultCountry = 'GB';
    } else if (timezone.indexOf('Amsterdam') > -1) {
        defaultCountry = 'NL';
    }

    const isUS =
        defaultCountry === 'US' &&
        (timezone === 'America/New_York' ||
            'America/Chicago' ||
            'America/Denver' ||
            'America/Los_Angeles');

    function changeValue(phone, isOptedOut) {
        if (isOptedOut) {
            setValue(`${phone}${optOutSuffix}`);
        } else {
            setValue(phone);
        }
    }

    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div>
                {isUS && (
                    <PhoneInput
                        defaultCountry={defaultCountry}
                        value={phone}
                        onChange={newValue => {
                            changeValue(newValue, isOptedOut);
                        }}
                    />
                )}
                {!isUS && (
                    <PhoneInputWithCountry
                        defaultCountry={defaultCountry}
                        value={phone}
                        onChange={newValue => {
                            changeValue(newValue, isOptedOut);
                        }}
                    />
                )}

                {showOptOut && (
                    <label className="mt-2 text-xs flex">
                        <input
                            type="checkbox"
                            className="mr-2"
                            checked={!isOptedOut}
                            onChange={ev =>
                                changeValue(phone, !ev.target.checked)
                            }
                        />
                        <div>
                            I agree to receive text messages from {businessName} via Breely related to my appointments and services. Messages may include confirmations and reminders. Message frequency varies. Message & data rates may apply. Reply STOP to cancel, HELP for help.
                            View our <a href="https://www.breely.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://www.breely.com/terms" target="_blank">Terms</a>.
                        </div>
                    </label>
                )}
            </div>
        </label>
    );
};

export default PhoneQuestion;
